import React from 'react';
import '../styles/pricing.scss'
import SERVICE_PREVIEW_DATA from './pricing.data'

class Pricing extends React.Component {
    constructor(props) {
        super(props)
    }

    state = {
        services: SERVICE_PREVIEW_DATA
    }


    render() {
        const { services } = this.state

        return (
            <div className="pricing">
                <div className="title">Special Pricing</div>
                <div className="sub-text">
                    We provide a wide variety of affordable nail and skin treatments for you.
                    <br />
                    Below you can learn more about the price range of our services.
                </div>

                <div className="service-preview">
                    {
                        services
                            .map(service =>
                                <div className="service-preview-item">
                                    <div className="service-preview-info">
                                        <span className="title">{service.title}</span>
                                        <span className="description">{service.description}</span>
                                    </div>
                                    <div className="price">${service.price}</div>
                                </div>)
                    }
                </div>
                <button className='custom-button button-default-outline' >
                    View More
                </button>
            </div>
        )
    }
}


export default Pricing